import { useEffect } from 'react';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { CustomVizOptionsSummaryDropdown } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';
import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { CustomVizHookDropdownOptionsFilterByIdFn } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const usePayBenchmarkingUpdateSelectableDropdownsEffect = ({
  dropdownOptions,
  filteredCustomVizDropdowns,
  setSelectableBenchmarks,
  setSelectableDepartments,
  setSelectableLocations,
  setSelectableEducationLabels,
  setSelectableCurrencies,
  language,
  shouldPrefillFilters,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
  filteredCustomVizDropdowns: CustomVizHookDropdownOptionsFilterByIdFn;
  setSelectableBenchmarks: Setter<CustomVizOptionsSummaryDropdown[]>;
  setSelectableDepartments: Setter<CustomVizOptionsSummaryDropdown[]>;
  setSelectableLocations: Setter<CustomVizOptionsSummaryDropdown[]>;
  setSelectableEducationLabels: Setter<CustomVizOptionsSummaryDropdown[]>;
  setSelectableCurrencies: Setter<CustomVizOptionsSummaryDropdown[]>;
  language: Phrases;
  shouldPrefillFilters: boolean;
}) => {
  return useEffect(() => {
    if (!shouldPrefillFilters) {
      return;
    }

    // TODO: Set if the external benchmark is available
    setSelectableBenchmarks([
      {
        dropdownId: 'benchmark',
        dropdownItemValue: 'external',
        dropdownItemText: 'External',
      },
    ]);

    const departments = filteredCustomVizDropdowns('department');
    setSelectableDepartments(departments);

    const selectableLocations = filteredCustomVizDropdowns('location');
    setSelectableLocations(selectableLocations);

    const selectableEducationLevels = filteredCustomVizDropdowns('education');
    setSelectableEducationLabels(selectableEducationLevels);

    setSelectableCurrencies([
      {
        dropdownId: 'currency',
        dropdownItemValue: 'USD',
        dropdownItemText: 'USD',
      },
    ]);
  }, [
    filteredCustomVizDropdowns,
    dropdownOptions,
    language,
    setSelectableBenchmarks,
    setSelectableDepartments,
    setSelectableLocations,
    setSelectableEducationLabels,
    setSelectableCurrencies,
    shouldPrefillFilters,
  ]);
};
